import { render } from "./InfoClienteRA.vue?vue&type=template&id=32023854&scoped=true"
import script from "./InfoClienteRA.vue?vue&type=script&lang=js"
export * from "./InfoClienteRA.vue?vue&type=script&lang=js"

import "./InfoClienteRA.vue?vue&type=style&index=0&id=32023854&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32023854"]])

export default __exports__